import React from 'react';

function createMarkup(t, body) {
  return {
    __html: t(body),
  };
}

const renderItems = (items, t) => {
  return (
    <div className="home-take-care-single-item">
      {items &&
        items.map((item, key) => {
          return (
            <div
              className="mb10"
              style={{ display: 'flex', flexDirection: 'row', width: '33%', alignItems: 'center' }}
            >
              <div>
                <img src={item.icon} className="home-take-care-icon" />
              </div>
              <div className="d-flex flex-column">
                <div className="font13 home-take-care-header">{t(item.heading).toUpperCase()}</div>
                <div
                  dangerouslySetInnerHTML={createMarkup(t, item.body)}
                  className="font10 home-take-care-body"
                ></div>
              </div>
            </div>
          );
        })}
    </div>
  );
};

const CareSection = ({ items, sectionTitle, t }) => {
  return (
    <div className="pullman-section-primary-row-container">
      <div className="pullman-section-primary-row">
        <div className="pullman-section-primary-row-main-heading black-text margin-T50 ">
          {sectionTitle}
        </div>
        <div className="pullman-section-primary-row-underline margin-B50"></div>
      </div>
      <div>{renderItems(items, t)}</div>
    </div>
  );
};

export default CareSection;



// WEBPACK FOOTER //
// ./src/features/home/CareSection/CareSection.js